import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'
import {
  CHART_CONFIGURATION_HANDLER,
  GENERATE_REPORT_COLUMNS,
  mapField,
  toField,
  VALUE_FORMATTERS,
} from './helpers.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let columns = useDataValue({
    context: 'report',
    path: 'columns',
    viewPath: props.viewPath,
  })
  let report_type = useDataValue({
    context: 'report',
    path: 'type',
    viewPath: props.viewPath,
  })

  let parsed = useMemo(() => {
    let parsed = { data: [], report: { columns: [] } }
    if (data) {
      try {
        // why do I need to parse it? shouldn't it be coming back in as JSON? maybe I need to set the mime type on the file
        parsed = JSON.parse(data)
      } catch (error) {}
    }

    return parsed
  }, [data])

  let columnsDef = useMemo(() => {
    let fields = Object.fromEntries(
      Object.values(columns)
        .flat()
        .map(item => [item.id, item])
    )

    return (
      GENERATE_REPORT_COLUMNS[report_type]?.(
        fields,
        parsed.report.columns,
        parsed.data
      ) ?? parsed.report.columns.map(column => toField(fields, column))
    )
      .filter(Boolean)
      .map(mapField)
      .map(mapColumn)
  }, [parsed, columns, report_type])

  return useMemo(() => {
    return {
      data: parsed.data,
      columns: columnsDef,
      original_data: {
        data: parsed.data,
        columns: columnsDef,
      },
      transposed: false,
      chart: CHART_CONFIGURATION_HANDLER[report_type]
        ? CHART_CONFIGURATION_HANDLER[report_type](props, parsed.data)
        : null,
    }
  }, [parsed, columnsDef, props, report_type])
}

function mapColumn(item, index, list) {
  if (item.children?.length) {
    item.children = item.children.map(mapColumn)
  }

  let valueFormatter =
    item.valueFormatter?.type in VALUE_FORMATTERS
      ? VALUE_FORMATTERS[item.valueFormatter.type]
      : undefined

  if (!valueFormatter) return item

  let filterParams = item?.filterParams || valueFormatter

  return {
    ...item,
    valueFormatter,
    filterParams,
  }
}
